<template>
  <div class="pdf" @close.stop>
    <div class="top">
      <i class="bi bi-download dowloadTop" @click="download()"></i>
    </div>
    <div id="contentConst" class="datos">
      <div class="modal-top">
        <img
          src="./../../../public//img/LogoConstancia.png"
          alt=""
          class="logoConstancia"
        />
      </div>

      <div class="titulo">
        <h3 style="text-align: left; text-decoration: underline">
          {{ title }}
        </h3>
      </div>

      <!-- DATOS DEL VECINO -->
      <div class="bodyModal">
        <p>
          <strong>Nombre:</strong>
          {{ obj?.lastname }}, {{ obj?.firstname }}
        </p>
        <p><strong>CUIL:</strong> {{ obj?.cuil }}</p>
        <p><strong>ID de Pago:</strong> {{ obj?.procedure }}</p>
        <p><strong>Número de Acta:</strong> {{ obj?.actNumber }}</p>

        <p v-if="obj.fecha != null">
          <strong>Fecha de pago:</strong>
          {{ new Date(obj?.fecha).toLocaleDateString() }}
        </p>
        <p><strong>Precio: </strong> ${{ obj?.price }}</p>
      </div>
      <div class="footerasd">
        <!-- <img
            src="./../../../public/img/pieConstancia.png"
            alt=""
            class="logoConstancia"
            style="border-radius: 0px 0px 25px 25px"
          /> -->
      </div>
    </div>
  </div>
</template>
<script>
// import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";

export default {
  name: "ModalMultaPagadaComponent",
  data() {
    return {
      title: "",
    };
  },
  created() {
    this.title = this.titulo;
    // window.scrollTo(0, 0);
  },
  props: {
    obj: Object,
    titulo: String,
    // close: Function,
  },
  components: {},
  computed: {},
  methods: {
    //METODO PARA DESCARGAR EN FORMATO PDF.
    numeroFormateado(asd) {
      // let asd = numero.toString().padStart(5, "0");
      let formateado = asd.toString().padStart(5, "0");
      return formateado;
    },

    download() {
      let element = document.getElementById("contentConst");
      //console.log("Elemento contentConst:", element);
      let options = {
        // margin: [30, 25, 25, 25], // Márgenes en mm
        filename: "documento.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 6, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      html2pdf()
        .set(options)
        .from(element)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          let totalPages = pdf.internal.getNumberOfPages();

          // Cargar imágenes
          // let encabezadoImg =

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);

            // Agregar imagen en el encabezado (posición x=10, y=5, tamaño 40x15 mm)
            // pdf.addImage(encabezadoImg, "PNG", 30, 5, 155, 15);

            // Agregar texto en el encabezado
            pdf.setFontSize(12);

            // Agregar imagen en el pie de página (posición x=10, y=275, tamaño 40x15 mm)
            // pdf.addImage(piePaginaImg, "PNG", 80, 285, 120, 10);

            // Agregar texto en el pie de página
            pdf.setFontSize(10);
          }
        })
        .output("blob")
        .then((pdfBlob) => {
          let pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl, "_blank"); // Abre en nueva pestaña en lugar de descargar
        });
    },
  },
};
</script>
<style scoped>
.pdf::-webkit-scrollbar {
  display: none;
}
.pdf {
  width: 837px;
  height: 537px;
  overflow-y: scroll;
  margin: auto;
  background: var(--bg-popup);
  border-radius: 25px;
  padding: 25px 0px 0px;
  text-align: left;
}
.documento {
  display: flex;
  flex-direction: row;
  gap: 15px;
  text-align: left;
  justify-content: space-between;
  margin-top: 10px;
  word-break: break-all;
}
.documento a {
  color: var(--color-danger);
  font-size: 17px;
  font-weight: 400;
}
.h5 {
  font-size: 15px;
  font-weight: 900;
  background: linear-gradient(
    270deg,
    #00c3a8 0.13%,
    #ffb900 47.51%,
    #ff2745 102.45%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.footerasd {
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 21px;
  position: absolute;
  bottom: 0;
  right: 0;
  gap: 15px;
  margin-top: 250px;
}
.footerasd img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.modal-top {
  width: 100%;
  height: 130px;
  overflow: hidden;
}
.titulo {
  margin-top: 32px;
  padding-left: 50px;
}
.logoConstancia {
  object-fit: fill;
  height: 130px;
  width: 100%;
}
.top {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 15px;
  justify-content: space-between;
  padding: 0px 42px;
  z-index: 1;
}

.bodyModal {
  width: 90%;
  text-wrap: wrap;
  height: auto;
  margin: auto;
  display: grid;
  gap: 20px;
  grid-template-columns: auto auto;
  /* min-height: 800px; */
  padding-bottom: 45px;
  margin-top: 54px;
}

.requerimiento {
  width: 95%;
  margin: auto;
  height: auto;
  background: rgba(217, 217, 217, 0.33);
  border-radius: 13px;
  padding: 20px 28px;
  margin-top: 25px;
  word-break: break-all;
  /* margin-bottom: 64px; */
}
.dowloadTop {
  font-size: 18px;
  position: absolute;
  top: 15px;
  cursor: pointer;
}
.datos {
  position: relative;
  height: 1100px;
  /* padding-bottom: 100px; */
}

@media (max-width: 770px) {
  .pdf {
    width: 274px;
    height: 269px;
    overflow-y: scroll;
    border-radius: 20px;
    margin: auto;
    padding-bottom: 20px;
  }
  .top {
    padding: 0px 20px;
    height: 11px;
    /* border-bottom: 15px solid var(--color-brand-blue); */
  }

  .modal-top {
    width: 100%;
    height: 61px;
    overflow: hidden;
  }
  .logoConstancia {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
  .titulo {
    margin-top: 20px;
    padding-left: 15px;
  }
  .titulo h3 {
    font-size: 10px;
    font-weight: 600;
  }
  .datos {
    position: relative;
    height: auto;
    /* padding-bottom: 30px; */
    width: 274px;
    margin: auto;
  }
  .bodyModal {
    width: 100%;
    text-wrap: wrap;
    height: auto;
    margin: auto;
    display: grid;
    gap: 8px;
    grid-template-columns: auto;
    padding-left: 15px;
    padding-bottom: 0px;

    margin-top: 16px;
  }
  .requerimiento {
    width: 95%;
    margin: auto;
    height: auto;
    background: rgba(217, 217, 217, 0.33);
    border-radius: 13px;
    padding: 20px 28px;
    margin-top: 20px;
    word-break: break-all;
    /* margin-bottom: 64px; */
  }
  p {
    font-size: 7px;
    font-weight: 600;
  }
  .documento {
    word-break: break-all;
  }
  .documento a {
    color: var(--color-danger);
    font-size: 7px;
    font-weight: 600;
    line-height: 13.539px;
    word-break: break-all;
  }

  .dowloadTop {
    font-size: 12px;
    position: absolute;
    top: 10px;
    cursor: pointer;
  }
  .footerasd {
    display: none;
  }
}
</style>
